module.exports = __webpack_public_path__ + "static/img/login_wh.198a8f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/login_wh.png
// module id = i0TD
// module chunks = 10